import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { actions as uiActions } from '@/reducers/ui';
import Glyph from '@gc-npm/components.icon-glyph';
import { COLORS } from '@gc-npm/utils.enums.colors';
import sendGaEvent from '@gc-npm/utils.metrics.send-ga-component-event';
import TextInfo, {
  TEXT_KIND,
  TEXT_COLOR,
  TEXT_SIZE,
} from '@gc-npm/components.text';
import CustomLink from '@gc-npm/components.custom-link';

const COMPONENT_NAME = 'TOOLTIP';

export const ToolTip = ({ notification }) => {
  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(uiActions.resetNotification())
  }

  const getTitulo = (texto) => {
    return texto.replace(/<[^>]*>/g, '');
  };

  const taggingInfoForToolTip = {
    componentContent: getTitulo(notification) || '',
    componentName: COMPONENT_NAME,
    componentProduct: '',
    componentVariation: '',
    eventType: 'print-success',
  }

  useEffect(() => {
    sendGaEvent(taggingInfoForToolTip)
  }, []);

  return (
    <div className="ToolTip">
      <div className="text">
        <TextInfo
          text={notification}
          size={TEXT_SIZE.BODY1}
          color={TEXT_COLOR.WHITE}
          kind={TEXT_KIND.PARAGRAPH}
        />
      </div>
      <div className="icon">
        <CustomLink taggingInfo={{ ...taggingInfoForToolTip, componentContent: 'cerrar' }} onClick={onClose}>
          <Glyph id="cerrar" height={20} width={20} color={TEXT_COLOR.WHITE} />
        </CustomLink>
      </div>

      <style jsx>
        {`
          .ToolTip {
              display: flex;
              flex-direction: row;
              width: 90%;
              max-width: 90%;
              border-radius: 4px;
              padding: 1rem;
              bottom: 6rem;
              position: fixed; 
              left: 50%; 
              transform: translateX(-50%); 
              background-Color: ${COLORS.movistarBlack};
              border-radius: 8px; 
              box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); 
              z-index: 1000; 
              text-align: center;
              .text {
                width: 90%;
              }
              .icon {
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                align-items: flex-start;
                width: 10%;
              }
          }
          @media (min-width: 768px) {
            .ToolTip {
              max-width: 500px;
            }
          }
        `}
      </style>
    </div>
  );
};

export default ToolTip;
